import { PATH_DASHBOARD } from './routes/paths'

export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app // as '/dashboard/app'

export const GENERAL_CONFIG = {}

export const DOMAIN_URL = window.location.origin
export const HOST_API = DOMAIN_URL + '/cms/api/'
export const ASSETS_API = DOMAIN_URL + '/cms'
export const HILABS_API = DOMAIN_URL + '/api'

export const GOOGLE_ANAYLTICS_KEY = GOOGLE_ANALYTICS_ID

// import { PATH_DASHBOARD } from './routes/paths'

// export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app // as '/dashboard/app'

// export const GENERAL_CONFIG = {}

// // only for dev/test
// const url = window.location.origin.includes('localhost')
//   ? 'http://10.20.5.199'
//   : window.location.origin
// export const DOMAIN_URL = url
// const isLoal = DOMAIN_URL.includes('http:') // only for dev/test
// // export const HOST_API = DOMAIN_URL +  '/cms/api/'
// // export const ASSETS_API = DOMAIN_URL +  '/cms'
// // export const HILABS_API = DOMAIN_URL +  '/api'

// export const HOST_API = `${DOMAIN_URL}${isLoal ? ':1337/api/' : '/cms/api/'}`
// export const ASSETS_API = `${DOMAIN_URL}${isLoal ? ':1337' : '/cms'}`
// export const HILABS_API = `${DOMAIN_URL}${isLoal ? ':8998/api' : '/api'}`

// export const GOOGLE_ANAYLTICS_KEY = GOOGLE_ANALYTICS_ID

// import { PATH_DASHBOARD } from './routes/paths'

// export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app // as '/dashboard/app'

// export const GENERAL_CONFIG = {}

// // only for dev/test
// const url = window.location.origin.includes('localhost')
//   ? 'http://10.20.5.199'
//   : window.location.origin
// export const DOMAIN_URL = url
// const isLoal = DOMAIN_URL.includes('http:') // only for dev/test
// // export const HOST_API = DOMAIN_URL +  '/cms/api/'
// // export const ASSETS_API = DOMAIN_URL +  '/cms'
// // export const HILABS_API = DOMAIN_URL +  '/api'

// export const HOST_API = `${DOMAIN_URL}${isLoal ? ':1337/api/' : '/cms/api/'}`
// export const ASSETS_API = `${DOMAIN_URL}${isLoal ? ':1337' : '/cms'}`
// export const HILABS_API = `${DOMAIN_URL}${isLoal ? ':8998/api' : '/api'}`

// export const GOOGLE_ANAYLTICS_KEY = GOOGLE_ANALYTICS_ID
